module.exports = __webpack_public_path__ + "img/send-verification-code.ec2c3a01.svg";